import { Component, OnInit } from "@angular/core";
@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.css"]
})
export class DocumentsComponent implements OnInit {
  folders = [
    {
      name: "ARTkart taurės taisyklės",
      updated: "2022/04/01",
      url: "https://docs.google.com/document/d/1BbbP6fTa3TzALMlA44psoxmORIhXl7I_/edit?usp=sharing&ouid=113568162067226766105&rtpof=true&sd=true"
    },
    // {
    //   name: "200 Ratų taisyklės",
    //   updated: "2021/04/01",
    //   url: "https://drive.google.com/file/d/1y4EhAYQ9WyBXRSWluYdH5V7u0naunwnx/view?usp=sharing"
    // },
    {
      name: "LKČ licenzijos",
      updated: "2022/04/01",
      url: "https://www.kartingas.lt/reglamentai/licencijos/vairuotojo-licencija"
    },
    {
      name: "safety-regulation",
      updated: "2022/04/01",
      url: "https://www.fiakarting.com/news/informative-note-fia-safety-department"
    }
  ];
  notes = [
    // {
    //   name: "DD2 PRO tech. reikalavimai",
    //   updated: "2021/04/01",
    //   url: "https://drive.google.com/open?id=1oDI1VI-MwWPyJyMvyK6CQEf1o67iIdOG"
    // },
    {
      name: "ART120 tech. reikalavimai",
      updated: "2022/04/01",
      url: "https://docs.google.com/document/d/1Ro3E_IyVpKAEr7h62mdAfTm59UQtmA0x/edit?usp=sharing&ouid=113568162067226766105&rtpof=true&sd=true"
    }
  ];

  schemes = [
    {
      name: "Vilnius",
      url: "https://drive.google.com/open?id=181k7CkN7VuSfSC_RA5XSs9EK5xmcDfSz",
      type: "2021/04/01"
    },
    {
      name: "Anyksciai",
      url: "https://drive.google.com/open?id=1pMlYgcGLjamWKbGidhARgjmy_Y9w15aN",
      type: "2021/04/01"
    },
    {
      name: "Smalininkai",
      url: "https://drive.google.com/open?id=1NSB06ZVlGQw3896L2IxMYtMgONuyGzbU",
      type: "2021/04/01"
    },
    {
      name: "Aukstadvaris",
      url: "https://drive.google.com/open?id=1G7SgWYhqqrLxiYUvdN0uv-guQDyYPF7p",
      type: "2021/04/01"
    },
    {
      name: "Elektrenai",
      url: "https://drive.google.com/open?id=1hNAEcxGEnurFftVU3WmHTvLvPesxscVD",
      type: "2021/04/01"
    },
    {
      name: "Kaunas",
      url: "https://drive.google.com/open?id=1xtKcpIBGsjU5_YIgw8m1ZZFcPn8qbEsA",
      type: "2021/04/01"
    }
  ];
  constructor() {}
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/documents/documents.component.ts